// TODO: Replace with a token claim once BE adds tenant_identifier to the login token.
// Until then the tenant identifier is environment-driven (PrefabDev / PrefabStage / PrefabProd)
// via the TENANT_IDENTIFIER env var, injected per deployment in the web pipeline.
export function useTenantId(): string {
	return import.meta.env.TENANT_IDENTIFIER || 'PrefabDev';
}
